module.exports = __webpack_public_path__ + "static/media/revenue-operations-feature-2.835b30f6.svg";